import React from 'react';
import { t } from '../../locales/i18n';
import styled from 'styled-components';
import { colors } from '../../themes';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  span {
    font-size: 15px;
  }
  span.title {
    width: 50px;
    font-size: 12px;
    color: ${colors.baseColors.grey};
  }
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function CardAttr(props: any) {
  return (
    <Wrapper>
      <div className="title">
        <span className="title">{t(props.title)}</span>
      </div>
      <div>
        <span>{props.children}</span>
      </div>
    </Wrapper>
  );
}
